import { LazyLoad } from 'app/utils';

export const ContactSortPage = LazyLoad(
  () => import('./index'),
  (module) => module.ContactSortPage,
);
